/**
 * @param {HTMLElement|HTMLButtonElement|null} button
 * @param {string} text
 * @returns {void}
 */

export const resetSubmitSpinner = (button, text = 'Submit') => {
  if (button) {
    button.removeAttribute('disabled')
    button.innerHTML = text
  }
}
